export default __webpack_public_path__ + "static/media/nail.2410fb3f.png";